import React from 'react';
import PropTypes from 'prop-types';
import { Box as MuiBox } from '@mui/material';

// Component scope - Constants and static data
const DISPLAY_OPTIONS = ['block', 'inline', 'flex', 'inline-flex', 'grid', 'inline-grid', 'none'];
const FLEX_DIRECTIONS = ['row', 'row-reverse', 'column', 'column-reverse'];
const JUSTIFY_CONTENT_OPTIONS = ['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'];
const ALIGN_ITEMS_OPTIONS = ['flex-start', 'center', 'flex-end', 'stretch', 'baseline'];

/**
 * App Box Component - Wrapper for MUI Box
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} AppBoxComponent
 */
const AppBoxComponent = ({
  display = 'block',
  flexDirection,
  justifyContent,
  alignItems,
  gap,
  padding,
  margin,
  width,
  height,
  minHeight,
  maxHeight,
  children,
  component = 'div',
  ...props
}) => {
  // Return/rendering
  return (
    <MuiBox
      display={display}
      flexDirection={flexDirection}
      justifyContent={justifyContent}
      alignItems={alignItems}
      gap={gap}
      padding={padding}
      margin={margin}
      width={width}
      height={height}
      minHeight={minHeight}
      maxHeight={maxHeight}
      component={component}
      {...props}
    >
      {children}
    </MuiBox>
  );
};

AppBoxComponent.propTypes = {
  display: PropTypes.oneOf(DISPLAY_OPTIONS),
  flexDirection: PropTypes.oneOf(FLEX_DIRECTIONS),
  justifyContent: PropTypes.oneOf(JUSTIFY_CONTENT_OPTIONS),
  alignItems: PropTypes.oneOf(ALIGN_ITEMS_OPTIONS),
  gap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  component: PropTypes.elementType,
  sx: PropTypes.object,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

export default AppBoxComponent;

